import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.excludedprivatestructure.address',
        defaultMessage: 'Address'
    },
    description: {
        id: 'ml.quoteandbind.excludedprivatestructure.description',
        defaultMessage: 'Description of Excluded Structure(s)'
    },
    action: {
        id: 'ml.quoteandbind.excludedprivatestructure.action',
        defaultMessage: 'Action'
    },
    addressLine1: {
        id: 'ml.quoteandbind.excludedprivatestructure.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.excludedprivatestructure.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.excludedprivatestructure.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.excludedprivatestructure.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.excludedprivatestructure.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.excludedprivatestructure.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.excludedprivatestructure.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.excludedprivatestructure.Remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.excludedprivatestructure.continueBtn',
        defaultMessage: 'Continue'
    },
    cancelBtn: {
        id: 'ml.quoteandbind.excludedprivatestructure.cancelBtn',
        defaultMessage: 'Cancel'
    },
    modalTitle: {
        id: 'ml.quoteandbind.excludedprivatestructure.modalTitle',
        defaultMessage: 'Add Excluded Private Structures'
    }
});
